import { useIntl } from 'react-intl';

export const useCohortAttritionWorkflowMessageKeys = () => {
  const intl = useIntl();

  return {
    draftTitle: intl.formatMessage({
      id: 'projects.cohortAttritionTable.workflowMessage.draft.title',
    }),
    draftMessage: intl.formatMessage({
      id: 'projects.cohortAttritionTable.workflowMessage.draft.message',
    }),

    processingTitle: intl.formatMessage({
      id: 'projects.cohortAttritionTable.workflowMessage.processing.title',
    }),
    processingMessage: intl.formatMessage({
      id: 'projects.cohortAttritionTable.workflowMessage.processing.message',
    }),

    errorTitle: intl.formatMessage({
      id: 'projects.cohortAttritionTable.workflowMessage.error.title',
    }),
    errorMessage: intl.formatMessage({
      id: 'projects.cohortAttritionTable.workflowMessage.error.message',
    }),
  };
};
